import { createModelSchemaWrapper, rawCopy } from 'framework/serializr-integration';
import { deserialize, list, object, primitive, serialize } from 'serializr';
import { makeAutoObservable } from 'mobx';

import { HealthReason } from 'framework/entities/healthReason';
import { AssetHealthIncidents } from 'areas/assets/details/types/assetHealthIncidents';
import { AssetHealthMonitor } from 'areas/assets/details/types/assetHealthMonitor';
import { AssetHealthQualifier } from 'areas/assets/details/types/assetHealthQualifier';
import { AssetHealthEvent } from 'framework/entities/events';
import { updateNotNullFields } from 'tools/helpers/array';

export class AssetHealth {
	assetHI: number;
	incidents: AssetHealthIncidents;
	lastStateChange: number;
	monitorDataUnavailable: boolean;
	monitorError: boolean;
	monitorMaintenance: boolean;
	monitors: AssetHealthMonitor[];
	numberOfIncidents: number;
	numberOfServices: number;
	qualifiers: AssetHealthQualifier[];
	reasons: HealthReason[];
	serviceState: boolean;
	servicesDown: number;

	constructor() {
		makeAutoObservable(this);
	}

	updateFromEvent(e: AssetHealthEvent) {
		const health = deserialize(AssetHealth, e.assetHealth);
		updateNotNullFields(this, health);
	}
}

createModelSchemaWrapper(AssetHealth, {
	assetHI: primitive(),
	incidents: object(AssetHealthIncidents),
	lastStateChange: primitive(),
	monitorDataUnavailable: primitive(),
	monitorError: primitive(),
	monitorMaintenance: primitive(),
	monitors: list(object(AssetHealthMonitor)),
	numberOfIncidents: primitive(),
	numberOfServices: primitive(),
	qualifiers: list(object(AssetHealthQualifier)),
	reasons: list(object(HealthReason)),
	serviceState: primitive(),
	servicesDown: primitive(),
});
